import type { PamongPenilaianRefleksiEvaluasiFormFields } from 'app/KinerjaPamongPage/types/pelaksanaan'
import type {
  IReflectionImprovementTypes,
  TStatePelaksanaanTranslated,
} from 'types/kinerja-pelaksanaan'

export const PAMONG_PRAKTIK_KINERJA_INDIKATOR_IMAGE: Record<string, string> = {
  'Komunikasi Visi Belajar': 'img-chalk-board-teach-character-stundet.png',
  'Identifikasi Kebutuhan Belajar': 'img-flow-process.png',
  'Presentasi Praktik Baik Program Pembelajaran': 'img-chat-talk.png',
  'Memandu Persiapan Pendidik Program Pembelajaran':
    'img-heart-empathic-give.png',
  'Melaksanakan Kegiatan Pembelajaran': 'img-book-rapor-graphic.png',
  'Memandu Refleksi Program Pembelajaran': 'img-curation-cards-screen.png',
  'Pendampingan Pelaksanaan Program Pembelajaran':
    'img-assessment-subject-book.png',
  'Pendampingan Peserta Didik Pasca Program Pembelajaran':
    'img-chalk-board.png',
}

export const PAMONG_PRAKTIK_KINERJA_GRADING_STATE_LABELS: Record<
  TStatePelaksanaanTranslated,
  string
> = {
  'Rating observasi': 'Observasi',
  'Nilai tindak lanjut': 'Rencana Tindak Lanjut',
  'Nilai refleksi tindak lanjut': 'Refleksi dan Evaluasi Tindak Lanjut',
  'Sudah selesai': 'Sudah Selesai',
}

export const PAMONG_DUKUNGAN_UPAYA_TINDAK_LANJUT = [
  'Sumber daya untuk melakukan kegiatan belajar/praktik',
  'Penyediaan atau pembelian alat dukung pembelajaran',
  'Penyediaan atau akses ke sumber belajar melalui satuan pendidikan',
  'Izin untuk mengikuti pelatihan di luar satuan pendidikan',
  'Memperoleh mentoring dari Kepala SKB, Pamong Belajar atau Pemateri Eksternal, atau Manajemen',
]

export const PAMONG_PENILAIAN_REFLEKSI_EVALUASI_FORM_FIELDS: Record<
  PamongPenilaianRefleksiEvaluasiFormFields,
  string
> = {
  additionalInspiration:
    'Inspirasi baru yang Pamong Belajar dapatkan dari upaya tindak lanjut:',
  additionalAchievement:
    'Berdasarkan inspirasi yang didapatkan, perubahan praktik Pamong Belajar di ruang kelas/satuan pendidikan:',
  additionalChallenge:
    '3 tantangan paling sulit yang Pamong Belajar hadapi dalam melakukan perubahan:',
  additionalImprovementPlan:
    'Rencana Pamong Belajar dalam mengatasi tantangan agar bisa memastikan perubahan terjadi:',
}

export const PAMONG_UPAYA_REFLEKSI_OPTIONS: Array<{
  value: IReflectionImprovementTypes
  label: string
  details: Array<string>
}> = [
  {
    value: 'MEET_EXPECTATION',
    label: 'Sadar tantangan dan penyebabnya berada di luar kendali diri',
    details: [
      'Menjelaskan penyebab tantangan yang berasal dari faktor eksternal (sarana prasarana, anggaran, koneksi sinyal, dll).',
    ],
  },
  {
    value: 'EXCEED_EXPECTATION',
    label: 'Sadar tantangan dan penyebabnya berada di dalam kendali diri',
    details: [
      'Menjelaskan penyebab tantangan yang berasal dari kemampuan atau keterbatasan dirinya, bukan dari faktor eksternal.',
    ],
  },
  {
    value: 'EXCEPTIONAL',
    label:
      'Sadar tantangan dan penyebabnya berada di dalam kendali diri serta dampaknya',
    details: [
      'Menjelaskan penyebab tantangan yang berasal dari kemampuan atau keterbatasan dirinya, bukan dari faktor eksternal.',
      'Menjelaskan dampak kualitas pembelajaran yang dirasakan murid disertai data, bukti lapangan, riset, atau Rapor Pendidikan.',
    ],
  },
]

export const PAMONG_UPAYA_MEMPELAJARI_OPTIONS: Array<{
  value: IReflectionImprovementTypes
  label: string
  details: Array<string>
}> = [
  {
    value: 'MEET_EXPECTATION',
    label: 'Melakukan upaya tindak lanjut',
    details: ['Melakukan upaya tindak lanjut yang sudah disepakati.'],
  },
  {
    value: 'EXCEED_EXPECTATION',
    label: 'Mempraktikkan inspirasi dari upaya tindak lanjut',
    details: [
      'Mendapatkan inspirasi dari upaya tindak lanjut yang telah dilakukan.',
      'Mempraktikkan inspirasi dari upaya tindak lanjut yang telah dilakukan.',
    ],
  },
  {
    value: 'EXCEPTIONAL',
    label: 'Membagikan praktik baik hasil inspirasi dari upaya tindak lanjut',
    details: [
      'Mempraktikkan inspirasi dari upaya tindak lanjut yang telah dilakukan.',
      'Membagikan praktik baik melalui komunitas belajar di dalam dan/atau luar satuan pendidikan.',
    ],
  },
]

export const PAMONG_PENINGKATAN_KINERJA_OPTIONS: Array<{
  value: IReflectionImprovementTypes
  label: string
  details: Array<string>
}> = [
  {
    value: 'MEET_EXPECTATION',
    label: 'Ada upaya melakukan peningkatan kinerja',
    details: [
      'Ada tindakan yang diambil untuk meningkatkan efektivitas, efisiensi, atau kualitas kinerja dalam suatu kegiatan atau pekerjaan.',
    ],
  },
  {
    value: 'EXCEED_EXPECTATION',
    label:
      'Upaya melakukan peningkatan kinerja sejalan dengan ekspektasi atasan',
    details: [
      'Ada tindakan yang diambil untuk meningkatkan efektivitas, efisiensi, atau kualitas kinerja dalam suatu kegiatan atau pekerjaan.',
      'Upaya melakukan peningkatan kinerja memenuhi atau melampaui standar yang disepakati bersama atasan.',
    ],
  },
  {
    value: 'EXCEPTIONAL',
    label:
      'Upaya melakukan peningkatan kinerja mendapatkan respon positif dari peserta didik',
    details: [
      'Upaya melakukan peningkatan kinerja memenuhi atau melampaui standar yang disepakati bersama atasan.',
      'Upaya melakukan peningkatan kinerja telah berjalan secara efektif sehingga diterima dan dihargai oleh para peserta didik.',
    ],
  },
]
